import { QueryStatus, QueryType } from '../../../API';

export enum HistoryCategory {
  Workbench = 'workbench',
  Scheduler = 'scheduler',
  FanSegment = 'fan-segment',
}

export type QuerySource = 'Scheduler' | 'Workbench';

export interface WorkbenchHistoryRecord {
  orgId: string;
  executionId: string;
  athenaExecutionId?: string | null;
  queryId: string;
  queryName: string;
  queryType?: QueryType | null;
  status: QueryStatus;
  querySource: QuerySource;
  schedulerName: string;
  lastModifiedAt: string;
  lastModifiedBy: string;
}

export interface SegmentHistoryRecord {
  executionId: string;
  queryId: string;
  segmentName: string;
  segmentDescription: string;
  segmentedFans: number;
  status: QueryStatus;
  createdOn: string;
  createdBy: string;
}

export type HistoryRow = (WorkbenchHistoryRecord | SegmentHistoryRecord) & {
  athenaExecutionId?: string | null;
  querySource?: string;
};

export type LogicalOperator = 'AND' | 'OR';

export interface SegmentConditionItem {
  column: string;
  operator: string;
  value: string;
  raw: string;
}

export interface SegmentConditionEntry {
  type: 'row' | 'group';
  joinWith?: LogicalOperator;
  row?: SegmentConditionItem;
  group?: SegmentConditionGroup;
}

export interface SegmentConditionGroup {
  entries: SegmentConditionEntry[];
}

export interface WorkbenchResultQueryRecord {
  orgId: string;
  queryId: string;
  executionId: string;
  athenaExecutionId: string;
  metadata: string;
}

export interface QueryResultColumn {
  key: string;
  label: string;
  sortOrder: null;
  sortFn: (a: Record<string, unknown>, b: Record<string, unknown>) => number;
  sortDirections: ('ascend' | 'descend' | null)[];
}
